import React, { type FC, type PropsWithChildren } from 'react';

import Box from '../box/box';
import type { Lucid } from '../../types/types';

export interface ShieldProps {
  /** Determines if shield should render above page content */
  shouldShowShield: boolean;
}

const ABTestShield: FC<PropsWithChildren<ShieldProps>> = ({ shouldShowShield }) =>
  shouldShowShield ? (
    <Box
      key="abTestShield"
      css={(theme: Lucid.Theme) => ({
        animation: `${theme.keyframe.hide} 4s step-end forwards`,
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        zIndex: 999999999,
      })}
    />
  ) : null;

export default ABTestShield;
